module.exports = __webpack_public_path__ + "static/media/brand1-small.9e5ad00c.jpg";